import cloneDeep from 'lodash/cloneDeep';

import { COLORS, COLORS_COUNT } from '@webapp/common/components/charts/constants';
import type { TChartColorSchemes } from '@webapp/common/resources/entities/survey-addons/params';

export const CIRCLE_CHART_SIZE_HEIGHT = 320;
export const CIRCLE_CHART_SIZE_WIDTH = 340;

export const SCHEMES = [
    {
        id: '1',
        colors: COLORS,
    },
    {
        id: '2',
        colors: [
            '#FF457E',
            '#FF5353',
            '#FF8F4A',
            '#FFDB45',
            '#4694FF',
            '#30E584',
            '#222324',
            '#848483',
            '#E0E0E0',
            '#FF3473',
        ],
    },
    {
        id: '3',
        colors: [
            '#C7EE5F',
            '#9594AD',
            '#F6580A',
            '#0D1E71',
            '#6060D7',
            '#263494',
            '#D1CBD8',
            '#4D51B8',
            '#544F55',
            '#1A1A1B',
        ],
    },
    {
        id: '4',
        colors: [
            '#E63946',
            '#EC9A9A',
            '#e1f4da',
            '#CDEAE5',
            '#A8DADC',
            '#77ABBD',
            '#457B9D',
            '#315B7A',
            '#1D3557',
            '#324766',
        ],
    },
    {
        id: '5',
        colors: [
            '#FFADAD',
            '#FFD6A5',
            '#ffe968',
            '#CAFFBF',
            '#9BF6FF',
            '#A0C4FF',
            '#BDB2FF',
            '#FFC6FF',
            '#d9d9d9',
            '#D0E1FF',
        ],
    },
    {
        id: '6',
        colors: [
            '#EEEFFF',
            '#9FB4C7',
            '#285B7B',
            '#A63358',
            '#C73866',
            '#FE676E',
            '#FB6F52',
            '#FFBD71',
            '#FFDCA2',
            '#B39DDB',
        ],
    },
];

export const DEFAULT_SCHEMES_IDS = SCHEMES.map((item) => item.id);

export const allChartColorSchemes = (chartColorSchemes: Array<any>) => {
    const clonedSchemes = cloneDeep(SCHEMES);

    if (chartColorSchemes?.length > 0) {
        return [...clonedSchemes, ...chartColorSchemes];
    }

    return clonedSchemes;
};

export const overflowPredefinedColors = (count: number): boolean => count > 10;

export const getColorByIndex = (index: number): string => COLORS[index % COLORS_COUNT];

export const fillArrayWithColors = (colors: Array<string>, length: number) => {
    const newColors = [...colors];

    if (length > colors?.length) {
        const lengthToAdd = length - colors.length;
        let colorIndex = 0;

        for (let i = 0; i < lengthToAdd; i++) {
            if (!colors[colorIndex]) {
                colorIndex = 0;
            }

            newColors.push(colors[colorIndex]);
            colorIndex++;
        }
    }

    return newColors;
};

export const getChartColors = (id: string, length?: number, chartColorSchemes?: TChartColorSchemes) => {
    let colors = COLORS;

    if (id) {
        const findScheme = allChartColorSchemes(chartColorSchemes).find((item) => item?.id === id);

        if (findScheme) {
            colors = [...findScheme?.colors];
        }
    }

    colors = fillArrayWithColors(colors, length);

    return colors;
};

// Палитра периодов сравнения: отдельная ось, чтобы цвет кодировал период, а не категорию.
export const getPeriodColors = (count: number, chartColorSchemes?: TChartColorSchemes): Array<string> => {
    const colors = allChartColorSchemes(chartColorSchemes)[0]?.colors || COLORS;

    return fillArrayWithColors([...colors], count);
};
